import { ForgotpasswordService } from './../../core/services/forgotPassword/forgotpassword.service';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  forgotPasswordFailed,
  forgotPasswordReceived,
  forgotPasswordRequest,
} from '../actions/forgotPasswordAction';

@Injectable()
export class forgotPasswordEffect {
  constructor(
    private actions: Actions,
    private forgotpasswordService: ForgotpasswordService,
  ) {}

  forgotPasswordRequest$ = createEffect(() =>
    this.actions.pipe(
      ofType(forgotPasswordRequest),
      mergeMap((params) =>
        this.forgotpasswordService
          .forgotPasswordRequest(params.forgotPasswordParams)
          .pipe(
            map((data) => forgotPasswordReceived({ data })),
            catchError((error) => of(forgotPasswordFailed({ error }))),
          ),
      ),
    ),
  );
}
